import React, { useEffect } from 'react';
import { Col } from 'reactstrap';
import { Helmet } from 'react-helmet';
import { sendVirtualPageView } from '../../shared/utility';
import PageBlockRenderer from './PageBlockRenderer';
import HTMLBlock from './HTMLBlock';

const Page = ({ pageTitle, showTitle = true, pageBody, hasExclusiveBlock = false }) => {
    const isBlockPage = Array.isArray(pageBody);
    const effectiveShowTitle = showTitle && !hasExclusiveBlock;

    useEffect(() => {
        sendVirtualPageView(pageTitle);
    }, [pageTitle]);

    return (
        <React.Fragment>
            <Helmet>
                <title>{`${pageTitle} | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
            </Helmet>
            <Col className="my-3" xs={12}>
                <article id="page-content">
                    {effectiveShowTitle !== false && <h1>{pageTitle}</h1>}
                    {isBlockPage ? (
                        <PageBlockRenderer blocks={pageBody} />
                    ) : typeof pageBody === 'string' ? (
                        <HTMLBlock html={pageBody} />
                    ) : null}
                </article>
            </Col>
        </React.Fragment>
    );
};

export default Page;
